import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataBoolean,
  ODataInteger
} from "pbas-vue-components";
import { translate2 } from '../trans2'
import { translate } from '../trans'
import { i18n } from '@/plugins/i18n';
import store from '@/store'

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 3
});

const formatter2 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

const ContributionTermsHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 2
  }),
  new ODataHeader({
    title: "headers.contributionterms.name",
    type: new ODataString("Name"),
    sortable: true,
    visible: true,
    searchable: true,
    version: 2
  }),
  new ODataHeader({
    title: "headers.t4a_archive.year",
    type: new ODataString("Year"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.contributionterms.name",
    type: new ODataString("Translations[]/Name"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    version: 2
  }),
  new ODataHeader({
    title: "headers.contributionterms.name",
    type: new ODataString("Translations[]/Year"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.start_date",
    type: new ODataDate("StartDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.end_date",
    type: new ODataDate("EndDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  
  new ODataHeader({
    title: "headers.contributionterms.completed",
    type: new ODataBoolean("IsCompleted"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("EmployerId"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("PlanId"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataInteger("Number"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/RefId"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Id"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    title: "enums.CalendarMonth",
    type: new ODataInteger("CalendarMonth"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "enums.CalendarYear",
    type: new ODataInteger("CalendarYear"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default ContributionTermsHeaders;
